import { axios } from "axios"
import { useState } from 'react';
import { useEffect } from 'react';
import "./TvSeries.css"
import { SingleContent } from './../SingleContent/SingleContent';
import { Pagination, PaginationPage } from './../Pagination/Pagination';
import { Genres } from './../Genres/Genres';
import { useGenres } from './../hooks/useGenres';


export const TvSeries = () => {
    const [tvSeriesContent, setTvSeriesContent] = useState([]);
    const [page, setPage] = useState(1)
    const [numOfPage, setNumOfPages] = useState()
    const [selectedGenres, setSelectedGenres] = useState([]);
    const [genres, setGenres] = useState([]);
    const genreforURL = useGenres(selectedGenres)

    const fetchTvSeriesData = () => {

        fetch(`https://api.themoviedb.org/3/discover/tv?api_key=55d3986357276fb32520164149dcabe4&language=en-US&sort_by=popularity.desc&include_adult=false&include_video=false&page=100&primary_release_year=2021&with_watch_monetization_types=flatrate&page=${page}&with_genres=${genreforURL}`)
            .then(res => res.json())
            .then(json => setTvSeriesContent(json.results))
            .then(json => setNumOfPages(json.total_pages))


    }


    useEffect(() => {
        window.scroll(0, 0)
        fetchTvSeriesData();
    }, [page, genreforURL])



    return (
        <>
            <div>
                <span className="pagetitle">TV SERIES</span>
                <Genres
                    type="movie"
                    setSelectedGenres={setSelectedGenres}
                    selectedGenres={selectedGenres}
                    genres={genres}
                    setGenres={setGenres}
                    setPage={setPage}
                />
                <div className="movie">
                    {tvSeriesContent && tvSeriesContent.map((ele) =>
                        // console.log(ele)
                        <SingleContent key={ele.id} output={ele} />
                    )}
                </div>
                <PaginationPage setPage={setPage} numOfPage={numOfPage} />


            </div>

        </>
    );
};